import { Component } from '@angular/core';
import { LocalizationFieldBase } from '../localization-field.base';

@Component({
  selector: 'app-localization-text-area-form-field',
  templateUrl: '../localization-field.component.html',
  styleUrls: ['../localization-field.component.scss']
})
export class LocalizationTextAreaFormFieldComponent extends LocalizationFieldBase {
  multiline = true;
}
